/* ============================================================
   HARD.NOISE — Particles + Scroll Reveal (rekonstruiert)
   Fehlte im Theme-Paket (404 referenziert). Neu aufgebaut nach
   _recon/RECON-REPORT.md.
   1) Dezenter Partikel-Canvas auf #hn-particle-canvas (Hero)
   2) Scroll-Reveal: blendet .hn-reveal beim Sichtbarwerden ein
   Idempotent (wird von hn-hero.liquid UND theme.liquid geladen).
   ============================================================ */
(function () {
  if (window.__HN_PARTICLES__) return;
  window.__HN_PARTICLES__ = true;

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1) Scroll-Reveal ---------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll('.hn-reveal:not(.is-visible)');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- 2) Partikel-Canvas -------------------------------- */
  function initParticles() {
    var canvas = document.getElementById('hn-particle-canvas');
    if (!canvas || reduceMotion) return;

    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = 0, h = 0, particles = [], raf = null;

    function resize() {
      var rect = canvas.getBoundingClientRect();
      w = rect.width; h = rect.height;
      canvas.width = Math.floor(w * dpr);
      canvas.height = Math.floor(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      seed();
    }

    function seed() {
      // Dichte an Fläche koppeln, aber gedeckelt (Performance).
      var count = Math.min(70, Math.round((w * h) / 22000));
      particles = [];
      for (var i = 0; i < count; i++) {
        particles.push({
          x: Math.random() * w,
          y: Math.random() * h,
          r: Math.random() * 1.4 + 0.4,
          vx: (Math.random() - 0.5) * 0.18,
          vy: (Math.random() - 0.5) * 0.18,
          a: Math.random() * 0.4 + 0.1
        });
      }
    }

    function draw() {
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        p.x += p.vx; p.y += p.vy;
        if (p.x < 0) p.x = w; else if (p.x > w) p.x = 0;
        if (p.y < 0) p.y = h; else if (p.y > h) p.y = 0;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(240,237,230,' + p.a + ')';
        ctx.fill();
      }
      raf = requestAnimationFrame(draw);
    }

    function start() { if (!raf) draw(); }
    function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } }

    // Nur animieren, wenn Canvas im Viewport ist (spart Akku/CPU).
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries[0].isIntersecting ? start() : stop();
      }, { threshold: 0 }).observe(canvas);
    } else {
      start();
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(resize, 200);
    }, { passive: true });

    resize();
  }

  function boot() { initReveal(); initParticles(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
